export default "__VITE_ASSET__DCKHVwSl__"